import { store } from "../store/index";
import {
  filterSector,
  removeSector,
  modifySector,
  getSectorByUuid,
  createSector,
  getAll,
} from "../store/actions/SectorActions";

/**
 * Create Sector
 */
export const addSector = async (values) => {
  const objSend = { ...values };
  delete objSend.viveroUuid;
  const result = await store.dispatch(createSector(objSend));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * Get Sector
 */
export const getSector = async (uuid) => {
  const param = [uuid];
  const result = await store.dispatch(getSectorByUuid(param));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Update Sector
 */
export const updateSector = async (values, uuid) => {
  const objSend = { ...values };
  delete objSend.viveroUuid;
  const result = await store.dispatch(modifySector(objSend, [uuid]));
  if (result?.payload?.data?.uuid) {
    return "OK";
  }
  return null;
};

/**
 * List Sector
 */
export const listFilter = async (filter) => {
  const result = await store.dispatch(filterSector(filter));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Delete Sector
 */
export const deleteSector = async (uuid) => {
  const result = await store.dispatch(removeSector([uuid]));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};

/**
 * Get all sectors
 */
export const getAllSectors = async (filters = {}) => {
  const result = await store.dispatch(getAll(filters));
  if (result?.payload?.data) {
    return result.payload.data;
  }
  return null;
};
